type BuildInfo = {
   app: string
   version: string
   commitSha: string | null
   branch: string | null
   buildUrl: string | null
   builtAt: string
}

declare const __APP_BUILD_INFO__: BuildInfo

export const APP_BUILD_INFO = __APP_BUILD_INFO__
